<template>
  <div class="promo-page">
    <!-- 头部标题区 -->
    <div class="header-section">
      <h1 class="main-title">建筑企业市场商机智能监测平台(市场营销大脑)</h1>
      <p class="sub-title">—— 智瞰·项目雷达 定制方案</p>
      <div class="contact-box">
        <el-row>
          <el-col :span="12">
            <div class="phone-number">
              <p class="tel">0755-82571568</p>
              <p class="tel">138 2884 8318</p>
            </div>
          </el-col>
          <el-col :span="12">
            <img class="wechat" src="../../assets/images/wechat_lss.png" alt="微信二维码" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 六大要点总览 -->
    <div class="overview-card">
      <div class="overview-tag">六大要点</div>
      <p class="overview-text">
        早期项目商机数据库 + 个性化监测系统开发 + 数据深度开发运营 + 数据资产入表 + AI大模型应用 + 打造标杆案例
      </p>
    </div>

    <!-- 折叠面板主体 -->
    <el-collapse v-model="activeNames" :accordion="false" class="custom-collapse">
      <!-- 要点一 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">
            <div class="item-avatar">
              <i class="el-icon-search"></i>
            </div>
            <div class="title-text">
              <span class="item-title">一、早期项目商机数据库：<span
                  class="font-normal highlight-text">比招标提前3-24个月，抢占竞争先机</span></span>
              <span class="item-slogan">
                <p>智瞰·项目雷达数据库，聚焦于早期建设项目商机挖掘，打通立项、可研、用地、规划、施工许可等
                  <span>11大政府审批节点</span>，
                  <span class="color-blue">比公开招标公告提前3-24个月捕捉项目源头信号</span>，为企业市场人员创造宝贵的业务开拓窗口期。
                </p>
              </span>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div class="content-box content-info">
            <div class="content-box-title">传统模式 vs 智瞰模式：</div>
            <ul class="content-list">
              <li><span class="list-dot"></span><strong>过去：</strong>在招标公告发布后才知道项目，通常只有20天左右准备标书，匆忙应战。</li>
              <li><span class="list-dot"></span><strong>现在：</strong>项目还在立项、用地规划阶段就已掌握情报，有充裕时间培育客户关系、打磨方案、筹备资源。</li>
            </ul>
            <div class="content-box-footer">
              <strong>核心价值：</strong>助力市场开发从随机性较高的"关系型营销"，转变为精准、可复制、可预测的<span
                class="color-blue">"数据驱动型营销"</span>，建立建筑业市场营销新模式。
            </div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 要点二 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">
            <div class="item-avatar">
              <i class="el-icon-monitor"></i>
            </div>
            <div class="title-text">
              <span class="item-title">二、个性化监测系统开发：<span class="font-normal highlight-text">把个人能力转化为组织能力</span></span>
              <span class="item-slogan">
                <p>
                  根据企业业务布局、擅长业态、目标区域等个性需求，量身定制市场商机监测系统。将分散在业务员个人手中的客户信息、项目情报、跟进经验，
                  <span class="color-blue">沉淀为企业级的标准化数字资产</span>。
                </p>
              </span>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div class="content-box content-success">
            <div class="content-box-title">典型场景：</div>
            <ul class="content-list">
              <li><span class="list-dot"></span>新业务员上岗，系统即刻推送其负责区域的历史客户关系图、在建项目动态和跟进建议</li>
              <li><span class="list-dot"></span>管理层无需等待月度汇报，可随时穿透查看任一区域、任一项目的实时进展</li>
            </ul>
            <div class="content-box-footer">
              <strong>核心价值：</strong>市场开拓能力不再依赖个别"能人"，而是固化在系统上，成为可传承、可复制、可管理的组织能力。人走了，客户和商机留下。
            </div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 要点三 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">
            <div class="item-avatar">
              <i class="el-icon-data-analysis"></i>
            </div>
            <div class="title-text">
              <span class="item-title">三、数据深度开发运营：<span class="font-normal highlight-text">从"看数据"到"用数据做决策"</span></span>
              <span class="item-slogan">
                <p>
                  将商机数据库与企业数据库、行业数据库、行业统计数据等多维数据深度融合，面向市场分析、竞争情报、商机挖掘及客户画像等核心业务场景进行深度开发。
                </p>
              </span>
            </div>
          </div>
        </template>
        <div class="collapse-content">

          <div class="content-box content-warning">
            <ul class="content-list">
              <li><span class="list-dot"></span><strong>市场布局优化：</strong>动态呈现各城市机会密度与竞争热度热力图，辅助判断"该去哪里布局、该从哪收缩"</li>
              <li><span class="list-dot"></span><strong>竞争对手洞察：</strong>监控主要对手的投标动向、报价区间、资质变化、区域扩张信号，知己知彼</li>
              <li><span class="list-dot"></span><strong>客户信用画像：</strong>基于历史合作数据与外部情报，评估业主付款能力与合作风险，避坑避险</li>
            </ul>
            <div class="content-box-footer">
              <strong>核心价值：</strong>让市场决策从"凭经验拍脑袋"升级为<span class="color-blue">"看数据定策略"</span>，每一次资源投入都有据可依。
            </div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 要点四 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">
            <div class="item-avatar">
              <i class="el-icon-document"></i>
            </div>
            <div class="title-text">
              <span class="item-title">四、数据资产入表：<span class="font-normal highlight-text">让IT投入转化为可增值战略资产</span></span>
              <span class="item-slogan">
                <p>
                  响应财政部《企业数据资源相关会计处理暂行规定》，将高质量的市场情报与企业客户数据转化为
                  <span class="color-blue">可在财务报表中确认的数据资产</span>。
                </p>
              </span>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div class="content-box content-primary">
            <div class="content-box-title">为什么这很重要：</div>
            <ul class="content-list">
              <li><span class="list-dot"></span><strong>传统IT项目：</strong>投入即消耗，体现为成本中心</li>
              <li><span class="list-dot"></span><strong>智瞰模式：</strong>随着系统持续运营和数据积累，数据资产价值将不断增长</li>
            </ul>
            <div class="content-box-footer">
              <strong>核心价值：</strong>本项目投入并非一项消耗性的IT开支，而是一项可持续增值的战略性投资。投入即资产，使用即增值。这也为企业探索数据资产化、参与数据要素市场建设，提供了一个可控、可见的落地抓手。
            </div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 要点五 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">
            <div class="item-avatar">
              <i class="el-icon-cpu"></i>
            </div>
            <div class="title-text">
              <span class="item-title">五、AI大模型应用：<span class="font-normal highlight-text">为企业"人工智能+"夯实数据底座</span></span>
              <span class="item-slogan">
                <p>
                  当前建筑企业纷纷部署大模型，但面临"有枪无弹"的困境——没有高质量、结构化、持续更新的领域数据，再强的大模型也无法产出有价值的业务成果。智瞰系统带来的不仅是市场商机，更是
                  <span class="color-blue">一套经过治理、持续更新、贴合建筑业务场景的高质量行业数据集</span>。
                </p>
              </span>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div class="content-box content-danger">
            <div class="content-box-title">价值延伸：</div>
            <ul class="content-list">
              <li><span class="list-dot"></span><strong>市场营销AI：</strong>智能商机评估、个性化情报推送、投标策略辅助</li>
              <li><span class="list-dot"></span><strong>合同风控AI：</strong>自动穿透200+风险条款，秒级风险评级</li>
              <li><span class="list-dot"></span><strong>经营分析AI：</strong>自然语言提问，直取市场洞察和战略建议</li>
            </ul>
            <div class="content-box-footer">
              <strong>核心价值：</strong>智瞰为企业推进"人工智能+"工程，提供了最紧缺、最基础、也最难替代的<span
                class="color-blue">数据底座</span>。让企业在AI应用落地上，从"看别人用"变为"自己能用、用好"。
            </div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 要点六 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">
            <div class="item-avatar">
              <i class="el-icon-trophy"></i>
            </div>
            <div class="title-text">
              <span class="item-title">六、标杆示范效应：<span class="font-normal highlight-text">既是好工具，更是好工程</span></span>
              <span class="item-slogan">
                <p>
                  本项目的建设，将成为建筑企业数智化转型的标志性工程，不仅是赋能业务的好工具，也是响应国家政策要求、提升企业行业影响力的好案例。
                </p>
              </span>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div class="content-box content-success">
            <ul class="content-list">
              <li><span class="list-dot"></span><strong>政策响应标杆：</strong>落实国家"人工智能+""数据要素×"战略的行业示范</li>
              <li><span class="list-dot"></span><strong>行业荣誉机会：</strong>具备条件申报央企数字化转型优秀案例、住建领域"数据要素×"典型案例</li>
              <li><span class="list-dot"></span><strong>对外品牌价值：</strong>为企业打造一张"数据驱动、智能决策"的数字化名片，提升行业影响力和品牌美誉度</li>
            </ul>
            <div class="content-box-footer">
              <strong>核心价值：</strong>智瞰不仅是一个赋能业务的好工具，更是一个推动转型、创造行业影响力的好工程，还是可对外传播的好故事。
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 底部联系区 -->
    <div class="footer-card">
      <div class="footer-content">
        <h3 class="footer-title">📞 联系我们</h3>
        <div class="contact-row">
          <div class="contact-card">
            <i class="el-icon-phone contact-icon"></i>
            <div class="contact-label"></div>
            <div class="contact-value">0755-82571568</div>
          </div>
          <div class="contact-card">
            <i class="el-icon-phone-outline contact-icon"></i>
            <div class="contact-label"></div>
            <div class="contact-value">400 008 0522</div>
          </div>
          <div class="contact-card">
            <i class="el-icon-mobile-phone contact-icon"></i>
            <div class="contact-label"></div>
            <div class="contact-value">138 2884 8318</div>
          </div>
        </div>
        <div class="qr-section">
          <p class="qr-text">企业微信联系</p>
          <div class="qr-placeholder">
            <img src="../../assets/images/wechat_lss.png" alt="企业微信二维码" />
            <!-- <i class="el-icon-picture-outline"></i> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoPage',
  data() {
    return {
      activeNames: '0'
    }
  }
}
</script>

<style scoped>
.header-section {
  position: relative;
}

.contact-box {
  position: absolute;
  top: 30px;
  right: 50px;
  width: 250px;
  text-align: center;
}
.phone-number{
  margin-top: 30px;
}
.contact-box .tel {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);;
  line-height: 33px;
}
.contact-box .wechat {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
.color-blue {
  color: #1a5fb4;
  font-weight: 600;
}

.promo-page {
  /* max-width: 1100px; */
  margin: 0 auto;
  padding: 20px;
  background: linear-gradient(135deg, #f0f4f8 0%, #e8ecf1 100%);
  min-height: 100vh;
}

/* 头部样式 */
.header-section {
  text-align: center;
  padding: 50px 30px;
  background: linear-gradient(135deg, #1a5fb4 0%, #3584e4 50%, #62a0ea 100%);
  border-radius: 20px;
  margin-bottom: 25px;
  box-shadow: 0 20px 60px rgba(26, 95, 180, 0.3);
  position: relative;
  overflow: hidden;
}

.header-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 30px 30px;
  opacity: 0.3;
}

.main-title {
  font-size: 2.4rem;
  color: #fff;
  font-weight: 700;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
  margin: 0;
}

.sub-title {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 10px;
  font-weight: 300;
  position: relative;
  z-index: 1;
}

/* 总览卡片 */
.overview-card {
  background: hsl(0, 0%, 100%);
  border-radius: 16px;
  padding: 30px 35px;
  margin-bottom: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border-left: 5px solid #3584e4;
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.overview-tag {
  background: linear-gradient(135deg, #3584e4, #1a5fb4);
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  flex-shrink: 0;
}

.overview-text {
  font-size: 1rem;
  color: #555;
  margin: 0;
  flex: 1;
}

/* 折叠面板自定义 */
.custom-collapse {
  border: none;
  background: transparent;
}

.custom-collapse>>>.el-collapse-item {
  margin-bottom: 25px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  background: #fff;
  transition: all 0.3s ease;
  border: 1px solid #eef2f7;
}

.custom-collapse>>>.el-collapse-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(26, 95, 180, 0.12);
  border-color: #c5d9f0;
}

.custom-collapse>>>.el-collapse-item__header {
  height: auto;
  padding: 22px 30px;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  color: #1a5fb4;
  background: linear-gradient(90deg, #f8fafc 0%, #fff 100%);
  border-bottom: 1px solid #f0f4f8;
  transition: background 0.3s;
}

.custom-collapse>>>.el-collapse-item__header:hover {
  background: linear-gradient(90deg, #ecf5ff 0%, #fff 100%);
}

.custom-collapse>>>.el-collapse-item__header.is-active {
  background: linear-gradient(90deg, #ecf5ff 0%, #fff 100%);
}

.custom-collapse>>>.el-collapse-item__wrap {
  border: none;
  background: #fff;
}

.custom-collapse>>>.el-collapse-item__content {
  padding: 0;
  background: #fff;
}

/* 标题自定义 */
.collapse-title {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
}

.item-avatar {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #3584e4, #1a5fb4);
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(53, 132, 228, 0.3);
}

.item-avatar i {
  font-size: 1.2rem;
  color: #fff;
}

.title-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-title {
  font-size: 1.15rem;
  color: #1a5fb4;
  font-weight: 600;
}

.item-slogan {
  font-size: 1rem;
  color: #888;
  font-weight: 400;
}

/* 内容区 - 段落文字 */
.collapse-content {
  margin-top: 20px;
  padding: 0;
}

.content-paragraph {
  padding: 22px 30px 0;
  color: #444;
  font-size: 0.98rem;
  line-height: 2;
  margin: 0 0 16px;
}

/* 高亮文字 */
.highlight-text {
  /* background: linear-gradient(180deg, transparent 60%, rgba(53, 132, 228, 0.15) 60%); */
  font-weight: 600;
  color: #1a5fb4;
}

/* 折叠内容盒子 */
.content-box {
  margin: 0 30px 24px;
  padding: 20px 24px;
  border-radius: 12px;
  border: 1px solid;
  background: #fafbfc;
}

.content-box-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #303133;
}

.content-box-title-inline {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 30px 12px;
  color: #303133;
}

.content-list {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
}

.content-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 6px 0;
  color: #444;
  font-size: 1rem;
  line-height: 1.8;
}

.list-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3584e4;
  flex-shrink: 0;
  margin-top: 8px;
}

.content-box-footer {
  padding-top: 12px;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  color: #444;
  font-size: 1rem;
  line-height: 1.8;
}

/* 不同主题色 */
.content-info {
  border-color: #a0cfff;
  background: #f0f9ff;
}

.content-info .content-box-title {
  color: #409eff;
}

.content-info .list-dot {
  background: #409eff;
}

.content-success {
  border-color: #b3e19d;
  background: #f0f9eb;
}

.content-success .content-box-title {
  color: #67c23a;
}

.content-success .list-dot {
  background: #67c23a;
}

.content-warning {
  border-color: #f3d19e;
  background: #fdf6ec;
}

.content-warning .content-box-title {
  color: #e6a23c;
}

.content-warning .list-dot {
  background: #e6a23c;
}

.content-primary {
  border-color: #a0cfff;
  background: #ecf5ff;
}

.content-primary .content-box-title {
  color: #1a5fb4;
}

.content-primary .list-dot {
  background: #1a5fb4;
}

.content-danger {
  border-color: #fab6b6;
  background: #fef0f0;
}

.content-danger .content-box-title {
  color: #f56c6c;
}

.content-danger .list-dot {
  background: #f56c6c;
}

/* 底部联系区 */
.footer-card {
  margin-top: 50px;
  background: linear-gradient(135deg, #1a5fb4 0%, #3584e4 100%);
  border-radius: 20px;
  padding: 40px 30px;
  color: #fff;
  text-align: center;
  box-shadow: 0 20px 60px rgba(26, 95, 180, 0.25);
}

.footer-title {
  font-size: 1.3rem;
  margin-bottom: 25px;
  font-weight: 500;
}

.contact-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px 40px;
  margin-bottom: 20px;
}

.contact-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px 30px;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
  min-width: 180px;
}

.contact-card:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
}

.contact-icon {
  font-size: 1.8rem;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.9);
}

.contact-label {
  font-size: 0.85rem;
  opacity: 0.8;
  margin-bottom: 4px;
}

.contact-value {
  font-size: 1.1rem;
  font-weight: 600;
}

.qr-section {
  margin-top: 15px;
}

.qr-text {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 10px;
}

.qr-placeholder {
  width: 120px;
  height: 120px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
}

.qr-placeholder i {
  color: rgba(255, 255, 255, 0.6);
  font-size: 2rem;
}

/* 响应式 */
@media (max-width: 768px) {
  .main-title {
    font-size: 1.5rem;
  }

  .sub-title {
    font-size: 1rem;
  }

  .header-section {
    padding: 40px 20px;
  }

  .overview-card {
    padding: 20px;
  }

  .collapse-title {
    gap: 10px;
  }

  .item-avatar {
    width: 36px;
    height: 36px;
  }

  .item-title {
    font-size: 1rem;
  }

  .item-slogan {
    font-size: 0.75rem;
  }

  .custom-collapse>>>.el-collapse-item__header {
    padding: 14px 16px;
  }

  .content-paragraph {
    padding: 16px 16px 0;
  }

  .content-box {
    margin: 0 16px 20px;
    padding: 16px;
  }

  .content-box-title-inline {
    margin: 0 16px 12px;
  }

  .contact-row {
    flex-direction: column;
    gap: 12px;
  }

  .contact-card {
    width: 100%;
  }
}

/* 动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-collapse>>>.el-collapse-item {
  animation: fadeInUp 0.5s ease forwards;
}

.custom-collapse>>>.el-collapse-item:nth-child(1) {
  animation-delay: 0.1s;
}

.custom-collapse>>>.el-collapse-item:nth-child(2) {
  animation-delay: 0.2s;
}

.custom-collapse>>>.el-collapse-item:nth-child(3) {
  animation-delay: 0.3s;
}

.custom-collapse>>>.el-collapse-item:nth-child(4) {
  animation-delay: 0.4s;
}

.custom-collapse>>>.el-collapse-item:nth-child(5) {
  animation-delay: 0.5s;
}

.custom-collapse>>>.el-collapse-item:nth-child(6) {
  animation-delay: 0.6s;
}
</style>